import React from 'reactn';
import { Typography, Button, Box, Divider } from '@material-ui/core';
import { Link } from 'react-router-dom';

import Page from 'components/Page';

const NotFound: React.FC = () => (
	<Page>
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="space-around"
			alignItems="center"
			height="30%"
		>
			<Typography variant="h3" component="h1">
				Page not found :(
			</Typography>
			<Divider />
			<Button color="secondary" variant="outlined" component={Link} to="/">
				Back Home
			</Button>
		</Box>
	</Page>
);

export default NotFound;
